import { PAGE_LAYOUT_VARIANT } from 'features/App';
import Integrations from './IntegrationsContainer';
import { watchActions } from './Integrations.saga';

export default [
  {
    path: '/integrations/:venueId?',
    component: Integrations,
    pageLayout: PAGE_LAYOUT_VARIANT.WIDE,
    pathSagas: [watchActions],
    hasMultipleColumns: true,
  },
];
